const sidebarNav = [
  {
    link: "/",
    section: "dashboard",
    icon: "lucide:layout-dashboard", //width:"20"
    text: "Dashboard",
    requiredRoles: []
  },
  {
    link: "/content",
    section: "Content",
    icon: "mdi:content-copy",
    text: "Content",
    requiredRoles: ['ViewContent']
  },
  {
    link: "/categories",
    section: "Categories",
    icon: "carbon:categories",
    text: "categories",
    requiredRoles: ['ViewCategory']
  },
  {
    link: "/mediatypes",
    section: "MediaTypes",
    icon: "pajamas:media",
    text: "mediatypes",
    requiredRoles: ['ViewMediaType']
  },
  {
    link: "/users",
    section: "Users",
    icon: "ph:users-bold",
    text: "Users",
    requiredRoles: ['ViewUser']
  },
  {
    link: "/privileges",
    section: "Privileges",
    icon: "ph:users-bold",
    text: "Privileges",
    requiredRoles: ['ViewRoleList']
  },


];


export const Permissions=[
  'ViewUser', 'AddUser', 'UpdateUser', 'UpdateUserStatus', 'ViewRoleList', 'AddRole',
  'UpdateRole', 'ViewCategory', 'AddCategory', 'UpdateCategory', 'UpdateCategoryStatus',
  'ViewMediaType', 'AddMediaType', 'UpdateMediaType', 'UpdateMediaTypeStatus', 'ViewContent',
  'AddContent', 'UpdateContent', 'PublishContent', 'DeleteContent'
]

export default sidebarNav;
